<div
	class="cis-table-container mt-2"
	[ngClass]="{ lock: isLoadingCiTable }"
	[ngStyle]="{
		'grid-template-columns': 'min-content repeat(' + ciTableHeader.length + ', 1fr) min-content',
		'grid-template-rows': 'repeat(' + (paginatedDataArr.length + 2) + ', 1fr)',
	}"
	id="cisTableContainer">
	<div
		class="table-line header"
		[ngClass]="{ 'long-row': ciTableHeader.length >= 8 }"
		[ngStyle]="{ 'grid-column-end': ciTableHeader.length + 3 }"
		#tableLineHeader>
		<div *ngFor="let header of ciTableHeader; let index = index">
			<div
				class="header-title"
				[ngClass]="{
					selected: sortBy == header.name,
					withParams:
						(search.values[index][0] && search.values[index][0] !== '') || (search.general[0] && search.general[0] !== ''),
				}">
				<div (click)="openDropdown(header.name, $event)">{{ labels[header.label] ? labels[header.label] : header.label }}</div>
				<div (click)="sortColumn(header.name); searchCITable(1)">
					<fa-icon [icon]="sortBy != header.name || sortDown ? icons.faSortUp : icons.faSortDown"></fa-icon>
				</div>
			</div>
			<div
				class="header-dropdown"
				[ngClass]="{ left: index > 4 }"
				*ngIf="(header.inputType === 'string' || header.inputType === 'date') && dropdown.name == header.name">
				<div class="search-container">
					<input
						[type]="header.inputType"
						[value]="search.values[index][0]"
						(input)="setSearchParam(index, $event.target.value)"
						(change)="setSearchParam(index, $event.target.value)" />
					<button class="search-button" (click)="searchCITable(1)"><fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon></button>
				</div>
			</div>

			<div
				class="header-dropdown"
				[ngClass]="{ left: index > 4 }"
				*ngIf="
					(header.inputType === 'select' || header.inputType === 'select-iac' || header.inputType === 'boolean') &&
					dropdown.name == header.name
				">
				<div class="search-container">
					<input type="text" [value]="search.filter[index]" (input)="search.filter[index] = $event.target.value" />
					<button class="search-button" (click)="searchCITable(1)"><fa-icon [icon]="icons.faMagnifyingGlass"></fa-icon></button>
				</div>
				<div class="option-container">
					<div class="option" (click)="setAllSearchParams(index)">
						<span
							><fa-icon
								[icon]="search.values[index].length == header.items.length ? icons.faCheckSquare : icons.faSquare"></fa-icon
						></span>
						<span>{{ labels.lbl_geral_selecionar_todos }}</span>
					</div>
					<div
						class="option"
						(click)="setSearchParam(index, item.values[0])"
						*ngFor="let item of header.items | callback: filterSearchOptions : index">
						<span
							><fa-icon
								[icon]="search.values[index].includes(item.values[0]) ? icons.faCheckSquare : icons.faSquare"></fa-icon
						></span>
						<span>{{ labels[item.label] ? labels[item.label] : item.label }}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="action-header">
			<span>{{ labels.lbl_bulletin_actions }}</span>
		</div>
	</div>

	<div
		class="table-line"
		[ngClass]="{ 'long-row': ciTableHeader.length >= 8 }"
		[ngStyle]="{ 'grid-column-end': ciTableHeader.length + 3 }"
		*ngFor="let ci of paginatedDataArr; let index = index">
		<!-- Select Multiplos -->

		<div
			[title]="handleCellValue(ci[header.name], header.inputType)"
			[ngStyle]="handleCellMarkup(ci[header.name])"
			#cellElement
			*ngFor="let header of ciTableHeader">
			<span>
				{{ handleCellValue(ci[header.name], header.inputType) }}
				<!-- {{header.inputType == 'date' ? DateService.formatDate(ci[header.name])
                    : labels[ci[header.name]] ? labels[ci[header.name]] :
                    ci[header.name]}} -->
			</span>
		</div>

		<div class="action-cell">
			<!-- <span [title]="labels.lbl_termo_digital" (click)="selectedModal = 'digitalTerm'; loadCmdbDigitalTerm(index);"><fa-icon [icon]="icons.faFile"></fa-icon></span> -->
			@if (idInconsistency) {
				<span
					[appTooltip]="
						ci.mark_as_solved ? labels.lbl_marcar_inconsistencia_nao_resolvida : labels.lbl_marcar_inconsistencia_resolvida
					"
					[tooltipOrientation]="{ right: true, top: true }"
					[ngClass]="{ 'disabled-by-permission': isTogglingSolved.includes(ci.id) }"
					(click)="toggleInconsistencyCiMarkAsSolved(ci.id)">
					<fa-icon [icon]="ci.mark_as_solved ? icons.faCheckSquare : icons.faSquare"></fa-icon>
				</span>
			}
			<span
				[appTooltip]="labels.lbl_geral_remover"
				[tooltipOrientation]="{ right: true, top: true }"
				[ngClass]="{ 'disabled-by-permission': isDisabled }"
				(click)="
					!isDisabled &&
						(confirmDelete.classList.contains('confirmClick') ? deleteCI(ci.id) : confirmButton(confirmDelete, $event))
				"
				#confirmDelete>
				<fa-icon [icon]="icons.faClose"></fa-icon>
			</span>
			<span [appTooltip]="labels.lbl_editar_item" [tooltipOrientation]="{ right: true, top: true }" (click)="navigateGoToCmdb(ci.id)">
				<fa-icon [icon]="icons.faWrench"></fa-icon>
			</span>
		</div>
		<div class="fog-container" *ngIf="isLoadingCiTable">
			<div class="loading-container">
				<cpi-svg-gears></cpi-svg-gears>
				<div>{{ labels.lbl_edocs_carregando }}!</div>
			</div>
		</div>
	</div>
</div>

<div class="pagination-container mt-2" *ngIf="ciTableCount > 0">
	<cpi-pagination-counter [arrayLength]="ciTableCount" [itemsPerPage]="itemsPerPage" (getCurrentPage)="searchCITable($event)">
	</cpi-pagination-counter>
</div>
